import { defineMessages } from 'react-intl';

export default defineMessages({
  trigger: {
    id : 'event_type.trigger.title',
    defaultMessage: 'Trigger'
  },
  schedule: {
    id: 'event_type.schedule.title',
    defaultMessage: 'Schedule'
  },
});
